import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["container"]

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    // Poll every 2 seconds for warming progress updates
    this.interval = setInterval(async () => {
      try {
        const response = await fetch(this.urlValue, {
          headers: {
            "Accept": "text/vnd.turbo-stream.html"
          }
        })

        if (response.ok) {
          const html = await response.text()
          Turbo.renderStreamMessage(html)
        } else {
          console.error("Failed to fetch warming progress")
        }
      } catch (error) {
        console.error("Error fetching warming progress:", error)
      }
    }, 2000)
  }

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}